import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { OVERLAY_CONTAINER_PROVIDER, OverlayContainer } from './overlay-container';
import {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  OverlayPosition,
} from './overlay-directives';
import { OverlayRef } from './overlay-ref';
import { OverlayState } from './overlay-state';
import { OverlayService } from './overlay.service';
import { GlobalPositionStrategy } from './position/global-position-strategy';
import { VIEWPORT_RULER_PROVIDER, ViewportRuler } from './position/viewport-ruler';
import { SCROLL_DISPATCHER_PROVIDER, ScrollDispatcher } from './scroll/scroll-dispatcher';
import { ScrollableDirective } from './scroll/scrollable.directive';

const DIRECTIVES = [ConnectedOverlayDirective, OverlayOriginDirective, ScrollableDirective];

@NgModule({
  imports: [CommonModule, ...DIRECTIVES],
  // We intentionally provide separate OverlayService for each module,
  // so the dialogs are opened in a scope of that module
  providers: [OverlayService],
  exports: [...DIRECTIVES],
})
export class RtUICoreOverlayModule {
  public static forRoot(): ModuleWithProviders<RtUICoreOverlayModule> {
    return {
      ngModule: RtUICoreOverlayModule,
      providers: [VIEWPORT_RULER_PROVIDER, SCROLL_DISPATCHER_PROVIDER, OVERLAY_CONTAINER_PROVIDER],
    };
  }
}

export {
  OverlayService,
  ViewportRuler,
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  ScrollableDirective,
  OverlayContainer,
  OverlayRef,
  OverlayState,
  ScrollDispatcher,
  OverlayPosition,
  GlobalPositionStrategy,
};
export * from './position/connected-position-strategy';
export * from './position/connected-position';
export { ComponentType } from './generic-component-type';
